import styled from "@emotion/styled";
import type { ReactNode } from "react";

interface HeaderProps {
  children?: ReactNode;
  className?: string;
}

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  max-width: 100vw;
  height: 105px;
  background: ${(props) => props.theme.colors.primary[700]};
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  clip-path: ellipse(100% 100% at 46% 0%);
  padding: clamp(1rem, 3vw, 2rem)
    clamp(1rem, 3vw, ${(props) => props.theme.spacing(3)})
    ${(props) => props.theme.spacing(1.5)};

  ${(props) => props.theme.breakpoints.up("tablet")} {
    padding: clamp(2rem, 5vw, 3rem)
      clamp(2rem, 5vw, ${(props) => props.theme.spacing(6)})
      ${(props) => props.theme.spacing(1.5)};
  }
`;

const HeaderClipPath = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 105px;
  background: linear-gradient(
    175deg,
    ${(props) => props.theme.colors.primary[1500]} 20%,
    ${(props) => props.theme.colors.primary[1000]} 100%
  );
  clip-path: ellipse(100% 100% at 5% 85%);
  pointer-events: none;
`;

const Badge = styled.div`
  position: absolute;
  top: ${(props) => props.theme.spacing(2)};
  right: ${(props) => props.theme.spacing(1.25)};
  background: ${(props) => props.theme.colors.secondary[1000]};
  color: ${(props) => props.theme.colors.neutral.white};
  padding: ${(props) => props.theme.spacing(0.5)}
    ${(props) => props.theme.spacing(1)};
  border-radius: ${(props) => props.theme.shape.borderRadiusXLarge};
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.captionBold.fontSize};
  font-weight: ${(props) => props.theme.typography.captionBold.fontWeight};
  white-space: nowrap;
  z-index: 10;

  ${(props) => props.theme.breakpoints.up("tablet")} {
    top: ${(props) => props.theme.spacing(2)};
    right: ${(props) => props.theme.spacing(2)};
  }
`;

export const Header = ({ children, className }: HeaderProps) => {
  return (
    <HeaderContainer className={className}>
      <HeaderClipPath />
      <Badge>#TribuPodemos</Badge>
      {children}
    </HeaderContainer>
  );
};
